import React from 'react';
import css from './css.less';
import Pricing from '../../Components/Pricing/Pricing';
import { useDispatch, useSelector } from 'react-redux';
import {
  setPrice,
  setAdvancedPrice,
  setAdvancedPriceAddNew,
  setAdvancedPriceSettingsOpen,
} from '../Slice';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import {
  TableInput,
  //TableSelect,
  TableNumberInput,
} from 'src/components/EditableTable/TableForm/TableForm';
import { EnumTablePosition } from 'src/types/common/common';
import { getCurrencies } from '@/src/constrains/GlobalProvider/slice';
//import { EnumMode } from '@/src/components/Antd/NumberInput/NumberInput';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { isNumber, get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { getBasicSetting } from 'src/constrains/GlobalProvider/slice';

const PricingSection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const storeSettings = useSelector(getBasicSetting());
  const storeDecimal = get(storeSettings, 'decimalPosition');
  const { productUuid, disabled } = props;
  const priceSettings = useSelector(
    (state: any) => state.simpleProduct.priceSettings,
  );
  const currencies = useSelector(getCurrencies());
  const advancedPriceSettings = useSelector(
    (state: any) => state.simpleProduct.advancedPriceSettings,
  );
  const advancedPriceSettingsOpen = useSelector(
    (state: any) => state.simpleProduct.advancedPriceSettingsOpen,
  );
  const dispatch = useDispatch();
  const priceSettingsOnChange = (data) => {
    dispatch(setPrice(data));
  };
  const advancedPriceSettingsOnChange = (isDelete, index, settings) => {
    dispatch(
      setAdvancedPrice({
        isDelete,
        index,
        settings,
      }),
    );
  };
  const advancedPriceSettingsAddNew = () => {
    dispatch(setAdvancedPriceAddNew());
  };
  const advancedPriceSettingsColOpen = () => {
    dispatch(setAdvancedPriceSettingsOpen());
  };
  const advancedOnChange = (index, setting) => {
    if (advancedPriceSettingsOnChange)
      advancedPriceSettingsOnChange(false, index, setting);
  };
  const columns = React.useMemo(() => {
    return [
      {
        title: () => <React.Fragment />,
        key: 'index',
        childGenerate: (text, record, index) => {
          return <span>{record?.displayIndex}</span>;
        },
        width: 100,
        default: true,
      },
      {
        title: () => (
          <div className={css.firstHeader}>
            {/* <EditIcon /> */}
            <span>
              {getI18n(
                'allProducts.addproductset.pricing_ProductionSetPricingSection_price_Tier',
              )}
            </span>
          </div>
        ),
        key: 'title',
        childGenerate: (text, record, index) => {
          const { title = '-' } = record;
          return (
            <NoWrapContainer>
              <Tooltip title={title}>{title}</Tooltip>
            </NoWrapContainer>
          );
        },
        minWidth: 410,
        default: true,
      },
      {
        title: () => (
          <div className={css.fontbackHeader}>
            <EditIcon />
            <span>{getI18n('allProducts.addproductset.listPrice')}</span>
          </div>
        ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          const { price, priceError, deletable } = record;
          return (
            <TableNumberInput
              disabled={disabled}
              // mode={EnumMode.money}
              label={isNumber(price) ? price.toFixed(2) : '-'}
              precision={2}
              error={priceError}
              rightPosition
              value={price}
              onFieldBlur={(value) => {
                if (!isNumber(price) && !deletable) {
                  advancedOnChange(index, { price: 0 });
                }
              }}
              onChange={(e) => {
                advancedOnChange(index, { price: e });
              }}
            />
          );
        },
        key: 'price',
        minWidth: 144,
        default: true,
      },
      {
        title: () => (
          <div className={css.fontbackHeader}>
            <EditIcon />
            <span>
              {getI18n('allProducts.addproductset.recommendRetailPrice')}
            </span>
          </div>
        ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          const { rrp, deletable } = record;
          return (
            <TableNumberInput
              disabled={disabled}
              // mode={EnumMode.money}
              label={isNumber(rrp) ? rrp.toFixed(2) : '-'}
              precision={2}
              // error={priceError}
              rightPosition
              value={rrp}
              onFieldBlur={(value) => {
                if (!isNumber(rrp) && !deletable) {
                  advancedOnChange(index, { rrp: null });
                }
              }}
              onChange={(e) => {
                advancedOnChange(index, { rrp: e });
              }}
            />
          );
        },
        key: 'rrp',
        minWidth: 184,
        default: true,
      },
      {
        title: () => (
          <div className={css.fontbackHeader}>
            <span>{getI18n('general.currency')}</span>
          </div>
        ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          const { currencyCode = '-' } = record;
          return (
            <NoWrapContainer>
              <Tooltip title={currencyCode}>{currencyCode}</Tooltip>
            </NoWrapContainer>
          );
        },
        key: 'currency',
        minWidth: 144,
        default: true,
      },
      {
        title: () => (
          <div>
            <EditIcon />
            <span>{getI18n('general.notes')}</span>
          </div>
        ),

        childGenerate: (text, record, index) => {
          const { notes, notesError } = record;
          return (
            <TableInput
              disabled={disabled}
              maxLength={500}
              error={notesError}
              value={notes}
              onChange={(e) => {
                advancedOnChange(index, { notes: e });
              }}
            />
          );
        },
        key: 'notes',
        minWidth: 412,
        default: true,
      },
    ];
  }, [advancedPriceSettings, currencies]);

  return (
    <Pricing
      disabled={disabled}
      productUuid={productUuid}
      columns={columns}
      priceSettings={priceSettings}
      advancedPriceSettings={advancedPriceSettings}
      priceSettingsOnChange={priceSettingsOnChange}
      advancedPriceSettingsOnChange={advancedPriceSettingsOnChange}
      advancedPriceSettingsAddNew={advancedPriceSettingsAddNew}
      advancedPriceSettingsOpen={advancedPriceSettingsOpen}
      setAdvancedPriceSettingsOpen={advancedPriceSettingsColOpen}
      storeDecimal={storeDecimal}
    />
  );
};
export default PricingSection;
